import axios from '@/libs/api.request'
export const feedbackPage = (param) => {
  return axios.request({
    url: '/weChat/feedback/page',
    params: param,
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/feedback-manage.js